import { jsx } from "react/jsx-runtime";
import { Form } from "@zillow/constellation";
import "react";
import MilitaryInstallationSelector from "../MilitaryInstallationSelector/MilitaryInstallationSelector.esm.js";
const MilitaryInstallationHomeSearch = () => {
  const handleInstallationChange = (value) => {
    window.location.assign(`https://www.tr1.test-automation.zillow.net/homes/${value.toLowerCase().replaceAll(" ", "-")}`);
  };
  return /* @__PURE__ */ jsx(Form, { children: /* @__PURE__ */ jsx(MilitaryInstallationSelector, { onChange: handleInstallationChange }) });
};
export {
  MilitaryInstallationHomeSearch as default
};
